import { ItemCompanyResource as Res } from '@shared/resources/item-company';
import { ItemCompanyCreateUpdateDto as DTO } from '@shared/dto/item_company';
import { CrudService } from './crud.service';

export class ItemCompanyService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'item-companies';
  }
}
